module.exports = __webpack_public_path__ + "static/index/img/baikal-507.52afc668.jpg";